import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import { format, parse } from "date-fns";
import { PropTypes } from "prop-types";

import { identifiersData } from "@/data";

const TimeInput = ({ errors, field, label, name, onChange, value }) => {
    const parsedValue = value ? parse(value, "HH:mm:ss", new Date()) : null;

    const onChangeHandler = (date) => {
        const timeString = date ? format(date, "HH:mm:ss") : "";
        field?.onChange?.(timeString);
        onChange?.(date, timeString);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <TimeField
                ampm={false}
                format="HH:mm:ss"
                label={label}
                slotProps={{
                    textField: {
                        error: !!errors?.[name],
                        helperText: errors?.[name]?.message,
                        id: `${name}_${identifiersData.ids.input}`,
                        sx: { input: { opacity: !value && 0.3 } },
                        fullWidth: true,
                    },
                }}
                {...field}
                value={parsedValue}
                onChange={onChangeHandler}
            />
        </LocalizationProvider>
    );
};

export default TimeInput;

TimeInput.propTypes = {
    errors: PropTypes.object,
    field: PropTypes.object,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string,
};
